import { Navigate, useLocation } from 'react-router-dom';

// Old public addresses stay alive (they are in emails, posts and QR codes):
// they redirect to the new official ones, keeping the query string (?eval=1,
// ?pid=…, ?curate=1) and the #fragment. The old → new map lives in
// legacyRoutes.json, shared with relish/server.js (which answers the same old
// addresses with a 301 before the app even loads).
export default function LegacyRedirect({ to }) {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: to, search, hash }} replace />;
}
